import clsx from 'clsx'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'
import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import SolidStarIcon from 'LuxKit/Icons/solid/SolidStarIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import styled from 'styled-components'
import type { LoyaltyLandingPageHowItWorksDetails } from './loyaltyLandingPageHowItWorks.types'

const HowItWorksPill = styled.div`
  height: ${rem(72)};
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${props => props.theme.borderRadius.round};
  padding: 0 ${rem(20)};
  width: auto;
  position: relative;

  /* A lone icon would sit in a 72px-wide lozenge, so the width is pinned to make it a circle. */
  &.single-icon {
    width: ${rem(72)};
    padding: 0;
    justify-content: center;
  }
`

/* Group's gap scale has no 6, which is what the designs space these icons by, so the row owns it. */
const IconRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${rem(6)};
`

/** Tiers shown in the Status Credits pill, weakest to strongest. */
const STATUS_TIERS: Array<App.LoyaltyTier> = ['silver', 'gold', 'platinum']

interface Props {
  item: LoyaltyLandingPageHowItWorksDetails
}

function LoyaltyLandingPageHowItWorksItem(props: Props) {
  const { item } = props

  return <Group
    direction="vertical"
    horizontalAlign="start"
    gap={16}
    key={item.title}
  >
    <HowItWorksPill className={clsx({ 'single-icon': item.type === 'savings' })}>
      {item.type === 'earn' && <IconRow>
        <LineBedIcon size="L" />
        <LinePlaneDepartureIcon size="L" />
        <LineShipIcon size="L" />
      </IconRow>}
      {item.type === 'savings' && <LineTagAltIcon size="L" />}
      {item.type === 'status' && <Group direction="horizontal" gap={2} verticalAlign="center">
        {STATUS_TIERS.map(tier => <SolidStarIcon key={tier} size="L" colour={`tier-${tier}`} />)}
      </Group>}
    </HowItWorksPill>
    <VerticalSpacer gap={8}>
      <Heading variant="heading4">{item.title}</Heading>
      <BodyText variant="medium">{item.description}</BodyText>
    </VerticalSpacer>
  </Group>
}

export default LoyaltyLandingPageHowItWorksItem
